module.exports = __webpack_public_path__ + "img/tradition@2x.671ad77.jpg";